import { AddContentToStateMeta, AddContentToStatePayload } from 'types/store/AddContentToState';
import { createAsyncReducer } from 'utils/Redux';

import { addContentToStateActions } from '../actions';

export default createAsyncReducer<AddContentToStateMeta, AddContentToStatePayload>(addContentToStateActions);
